import { useEffect, useState } from "react";
import MyAccountLink from "./MyAccountLink";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { userData } from "../utils/constants";

const TopAddress = () => {

    const [name, setName] = useState('');
    const [avatar, setAvatar] = useState(null);

    useEffect(() => {
        let data = getFromLocalStorage(userData);
        setName(data?.name);
        setAvatar(data?.avatar)
    }, []);

    const getInitials = (name) => {
        if (!name) return '';
        return name.charAt(0).toUpperCase();
    };

    return (
        <div className="col-12 col-md-4 mb-4 mb-md-0 text-center">
            <div className="bg-white border shadow-sm p-4" style={{ borderRadius: '12px' }}>
                <div className="pb-4 border-bottom mb-4">
                    <div className="mx-auto mb-3" style={{ width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', border: '3px solid #fff', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                        {avatar ? (
                            <img src={avatar} alt="User Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                            <div className="d-flex align-items-center justify-content-center h-100 w-100 text-white fw-bold" style={{ backgroundColor: 'var(--primary)', fontSize: '2.5rem' }}>
                                {getInitials(name)}
                            </div>
                        )}
                    </div>
                    <div>
                        <h5 className="fw-bold text-dark mb-2">{name}</h5>
                        <span className="badge bg-success text-white px-3 py-2" style={{ borderRadius: '20px', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Verified Account <i className="fas fa-check-circle ml-1"></i></span>
                    </div>
                </div>

                <div className="text-left">
                    <h6 className="fw-semibold text-uppercase text-secondary mb-3" style={{ fontSize: '0.8rem', letterSpacing: '1px' }}>Menu</h6>
                    <div className="mb-0">
                        <MyAccountLink />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopAddress;